import script from "./ConnectedActivityLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectedActivityLogs.vue?vue&type=script&setup=true&lang=js"

import "./ConnectedActivityLogs.vue?vue&type=style&index=0&id=b36e29da&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b36e29da"]])

export default __exports__